import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import "../Styles/blogs.css";

const ITEMS_PER_PAGE = 24;
const MIN_PAGES = 5;

/*
✅ IMPORTANT RULE:
Whenever you add a new blog,
👉 ADD IT AT THE TOP of this array
*/
const blogs = [
  // ✅ NEW BLOG ALWAYS ADD HERE
  // { id: 13, image: "/assets/v_13.png", title: "New Blog", path: "/ins-13" },
  { id: 26, image: "/hugging.png", title: "The Data Behind Job Hugging: What HR Leaders Should Measure", path: "/hugging",date: "October 20, 2026", newStyle: true, link: "/hugging" },
   { id: 25, image: "/beyond.png", title: "Beyond Salary Hikes: 7 Smart HR Strategies to Improve Employee Retention", path: "/beyondsalaryhikes",date: "October 5, 2026", newStyle: true, link: "/beyondsalaryhikes" },
    { id: 24, image: "/met.png", title: "Understanding Employee Productivity: Metrics, Drivers & Strategies", path: "/employeeproductivity",date: "September 30, 2026", newStyle: true, link: "/employeeproductivity" },
  { id: 23, image: "/Ashely_main_img.png", title: "At Ashley Furniture India, Innovation Meets People-First Practices to Create an Outstanding Workplace", path: "/ashley",date: "September 3, 2026", newStyle: true, link: "/ashley" },
  { id: 22, image: "/Manuf_main_img.png", title: "The Culture Advantage: How Manufacturing Workplaces Can Win Through People", path: "/manufacture",date: "September 3, 2026", newStyle: true, link: "/manufacture" },
   { id: 21, image: "/sur.png", title: "Why Employee Engagement Surveys Are Becoming a Retention Strategy in India", path: "/employee-survey",date: "August 27, 2026", newStyle: true, link: "/employee-survey" },
  { id: 20, image: "/gc.png", title: "From Cost Centre to Capability Centre: The New Era of GCCs", path: "/gcc", date: "August 27, 2026", newStyle: true, link: "/gcc" },
  { id: 19, image: "/dec.png", title: "Why Employee Engagement Is Declining in Indian Organizations - And What Leaders Can Do",path: "/leaders",  date: "August 27, 2026", newStyle: true, link: "/leaders" },
  { id: 18, image: "/assets/v_18.png", title: "Work-Life Balance Examples to Boost Employee Engagement", path: "/worklife-balance" },
  { id: 17, image: "/assets/v_17.png", title: "Workplace Best Practices: Building a Culture That Drives Success", path: "/best-practices" },
  { id: 16, image: "/assets/v_16.png", title: "Outstanding Workplaces Launches HR Voices Event Series", path: "/hr-voices" },
  { id: 15, image: "/assets/v_15.png", title: "The Heart of Modern Workplaces HR Voices by Outstanding Workplaces", path: "/modern-workplaces" },
  { id: 14, image: "/assets/v_14.png", title: " Building Workplaces People Choose HR Voices by Outstanding Workplaces", path: "/building-workplaces" },
  { id: 13, image: "/assets/v_13.png", title: "Shaping the Future of Work HR Voices by Outstanding Workplaces", path: "/shaping-future" },
  { id: 1, image: "/assets/v_1.png", title: "", path: "/novac-tech", badge: true },
  { id: 2, image: "/assets/v_2.png", title: "", path: "/aziro-tech", badge: true },
  { id: 3, image: "/assets/v_3.png", title: "When Good Hires Go Wrong: The Truth About Gut Decisions", path: "/good-hire" },
  { id: 4, image: "/assets/v_4.png", title: "Boost employee engagement with recognition programs, open communication, and growth opportunities to create a thriving workplace culture.", path: "/employee-engagement" },
  { id: 5, image: "/assets/v_5.png", title: "Employee Wellbeing – Prioritize physical, mental, and emotional health.", path: "/employee-well" },
  { id: 6, image: "/assets/v_6.png", title: "Inclusive Culture – Promote diversity and ensure every voice is valued.", path: "/promote-tech" },
  { id: 7, image: "/assets/v_7.png", title: "Where Values Drive Engagement and Growth", path: "/drive-management" },
  { id: 8, image: "/assets/v_8.png", title: "Showcasing What Makes Your Workplace Irresistible", path: "/show-casing" },
  { id: 9, image: "/assets/v_9.png", title: "Talent Acquisition That Reflects Our Culture and Values", path: "/talent-acquisition" },
  { id: 10, image: "/assets/v_10.png", title: "Visionary Leadership: Shaping Culture Through Forward-Thinking Impact", path: "/visionary-tech" },
  { id: 11, image: "/assets/v_11.png", title: "Foster an environment where every employee feels valued, heard, and empowered to contribute", path: "/foster-environment" },
  { id: 12, image: "/assets/v_12.png", title: "Cultivating a Learning-First Culture", path: "/learning-culture" },
];

// Categories
const categories = [
  { label: "All Blogs", path: "/blogs" },
  { label: "Workplace Best Practices", path: "/work" },
  { label: "Employee Engagement", path: "/Engagement" },
  { label: "Employee Branding", path: "/Brand" },
  { label: "Thought Leadership & Workplace Culture", path: "/Thought" },
];

const getPageWindow = (current, total) => {
  const windowSize = 1;
  let start = Math.max(1, current);
  let end = start + windowSize - 1;

  if (end > total) {
    end = total;
    start = Math.max(1, end - windowSize + 1);
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

// Dropdown
const CustomDropdown = ({ selected, setSelected, onNavigate }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      

      {open && (
        <div className="dropdown-list">
          {categories.map((item, index) => (
            <div
              key={index}
              className="dropdown-item"
              onClick={() => {
                setSelected(item.label);
                setOpen(false);
                onNavigate(item.path);
              }}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const BlogPage = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("All Blogs");
  const [searchParams, setSearchParams] = useSearchParams();

const currentPage = parseInt(searchParams.get("page")) || 1;

  const realTotalPages = Math.ceil(blogs.length / ITEMS_PER_PAGE);
  const totalPages = Math.max(realTotalPages, MIN_PAGES);

 const handlePageChange = (n) => {
  if (n < 1 || n > totalPages) return;

  setSearchParams({ page: n });
  window.scrollTo(0, 0);
};

  // ✅ NO SORTING — uses original order
  const pageBlogs = blogs.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const pageWindow = getPageWindow(currentPage, totalPages);

  return (
    <div className="blog-container">
      {/* HEADER */}
      <div className="header">
        <h2>Resources & Insights Hub</h2>
        <CustomDropdown
          selected={selectedCategory}
          setSelected={(label) => {
  setSelectedCategory(label);
  setSearchParams({ page: 1 }); // ✅ correct
}}
          onNavigate={(path) => navigate(path)}
        />
      </div>

      <div className="grid">
  {pageBlogs.length > 0 ? (
    pageBlogs.map((blog) =>
      blog.newStyle ? (
        // 🆕 NEW CARD STYLE
        <div
          className="blog-card blog-card-new"
          key={blog.id}
          onClick={() => blog.path && navigate(blog.path)}
        >
          <div className="blogs-image-wrapper blogs-image-wrapper-new">
            {blog.image ? (
              <img src={blog.image} alt="" className="blogs-image" />
            ) : (
              <div className="blogs-image-placeholder" />
            )}
          
          </div>

          <p className="blog-title">{blog.title}</p>
          <div className="blog-date">
  <img src="/date_box.png" alt="" className="date-icon" />
  {blog.date}
</div>
          <a
            href={blog.link}
            className="blog-read-more"
            onClick={(e) => e.stopPropagation()}
            style={{ whiteSpace: "nowrap", textDecoration: "none" }}
          >
            Read More →
          </a>
        </div>
      ) : (
        // EXISTING CARD STYLE
        <div
          className="blog-card"
          key={blog.id}
          onClick={() => blog.path && navigate(blog.path)}
        >
          <div className="blogs-image-wrapper">
            <img src={blog.image} alt="" className="blogs-image" />
            {blog.badge && (
              <img src="/assets/blog_badge.png" alt="badge" className="blogs-badge" />
            )}
          </div>
          <p className="blog-title">{blog.title}</p>
        </div>
      )
    )
  ) : (
    <p className="no-results">No blogs found.</p>
  )}
</div>

      {/* PAGINATION */}
      <div className="pagination">
        <button
          className="page-btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ← Previous
        </button>

        <div className="page-numbers">
          {pageWindow.map((n) => {
            const isDisabled = n > realTotalPages;
            return (
              <span
                key={n}
                className={`${n === currentPage ? "active" : ""} ${
                  isDisabled ? "disabled" : ""
                }`}
                onClick={() => !isDisabled && handlePageChange(n)}
              >
                {n}
              </span>
            );
          })}
        </div>

        <button
          className="page-btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === realTotalPages}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default BlogPage;
